(function () {
  'use strict';

  function initPressLogos(section) {
    var grid = section.querySelector('[data-pl-grid]');
    if (!grid) return;

    var cards = Array.prototype.slice.call(grid.querySelectorAll('.press-logos__card'));
    if (!cards.length) return;

    if (!('IntersectionObserver' in window)) return;

    cards.forEach(function (card) {
      card.classList.add('pl-animate-ready');
    });

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -32px 0px' }
    );

    cards.forEach(function (card, index) {
      card.style.transitionDelay = (index * 60) + 'ms';
      observer.observe(card);
    });
  }

  function initAll() {
    document.querySelectorAll('.press-logos').forEach(initPressLogos);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.press-logos');
    if (section) initPressLogos(section);
  });
})();
